import { Route } from "react-router-dom";
// import ManageDefaultRoutes from "../ManageDefaultRoutes";
import Notification from "../../pages/Notification/Index";

const NotificationRoutes = (
  <>
    <Route path="notification/*">
      {/* <Route index element={<ManageDefaultRoutes path="" />} /> */}
      <Route  index element={<Notification />} />
    </Route>
  </>
);
export default NotificationRoutes;
